//本地测试
// const host ="https://test.anqingzhiyun.com/api/h5/"
//线上地址
const host ="https://viphk10000.anqingzhiyun.com/api/h5/"

const timeout = 5000

export default {
	host,
	timeout
}